import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './fonts/PFAgoraSlabPro-Black.ttf';
import './fonts/SuisseIntl-Black.otf';
import {createStore} from 'redux';
import {Provider} from 'react-redux';
import './components/themes.css';
import ThemeProvider from './providers/themeProvider';
import './index.css';
import { Appearance } from 'react-native';

const colorScheme = Appearance.getColorScheme(); 

const defaultState = {
  rev: "",
  star: 0,
  depNum: 0,
  sendRev: false,
}

const reducer = (state = defaultState, action) => 
{
    switch (action.type)
    {
        case "ADD_STAR":
          return {...state, star: action.payload}
        case "ADD_REV":
          return {...state, rev: action.payload}
        case "ADD_DEPNUMBER":
          return {...state, depNum: action.payload}
        case "GET_CASH":
          return {...state, cash: state.cash - action.payload}
        case "ADD_SEND_REV":
          return {...state, sendRev: action.payload}
        default:
          return state
    }
}

const store = createStore(reducer)


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Provider store={store}>
      <React.StrictMode>
      <ThemeProvider themeNew = {colorScheme}>
        <App/>
      </ThemeProvider>
      </React.StrictMode>
    </Provider>
);
